function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.23,389.24c68.91,32.84,180.63,32.85,249.54,0s68.9-86.09,0-118.93-180.63-32.84-249.54,0S56.33,356.4,125.23,389.24Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-32"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 374.53,
    cy: 354.02,
    rx: 22.98,
    ry: 10.95,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,355.59l8.13-4.69a32.54,32.54,0,0,0,10-14.07c2.51-6.92,2.16-12.18.36-14.82-2.21-3.25-7.94-2.68-8.17,4.16C129.84,339.65,125.91,349,120,355.59Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,355.59l8.13-4.69a32.54,32.54,0,0,0,10-14.07c2.51-6.92,2.16-12.18.36-14.82-2.21-3.25-7.94-2.68-8.17,4.16C129.84,339.65,125.91,349,120,355.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,356.09a.5.5,0,0,1-.28-.91c18.8-13,15.16-31.13,15.12-31.31a.5.5,0,1,1,1-.21c0,.19,3.84,18.94-15.52,32.34A.52.52,0,0,1,120,356.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.71,365s-2.83-2.3-2.15-5.42,2.51-5.36-.62-9.38-4-9.38-.26-12.28c2.85-2.25,7.3.93,8.9-5,1.18-4.34.78-13.95,6.31-17.15s9,1.62,8.13,8.14c-.76,5.83-1.84,11.44-1,13,1.62,3,4.39,2.59,4.26,8.07-.11,5.1-4.94,9.32-4.94,9.32Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,360.11a.51.51,0,0,1-.5-.44c-1.43-11.85,2-32.31,4.8-38.39A.5.5,0,0,1,118,321a.49.49,0,0,1,.24.66c-2.77,6-6.08,26.52-4.71,37.85a.5.5,0,0,1-.44.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.73,350.88a.42.42,0,0,1-.22-.05c-3.47-1.69-5.67-7.72-5.76-8a.5.5,0,1,1,.94-.34c0,.06,2.15,5.9,5.26,7.41a.5.5,0,0,1-.22.95Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.67,354.88a.49.49,0,0,1-.46-.32.5.5,0,0,1,.27-.65c5.84-2.34,9.48-9.29,9.52-9.37a.5.5,0,0,1,.89.46c-.16.3-3.85,7.36-10,9.84A.43.43,0,0,1,112.67,354.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.8,301.08S312.43,294,312,286.31s1.26-10.89,3.58-11.81,2.5,1.91,3.69,3.58,3.62.72,4.52-4.49,4.18-14,11-15.71c7.5-1.86,3.48,6.94,1.59,10.37s-3.35,8.11-2.11,9.38,3.17-1.08,5,1.1c2.23,2.63-4.7,12.1-8.68,14.39Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.79,298.11h0a.5.5,0,0,1-.48-.52,72,72,0,0,1,11.2-34.8.49.49,0,0,1,.7-.11.5.5,0,0,1,.11.69,71.08,71.08,0,0,0-11,34.27A.5.5,0,0,1,322.79,298.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.36,292.2a.53.53,0,0,1-.24-.06c-2.8-1.55-4.35-6.15-4.41-6.34a.5.5,0,0,1,.31-.64.5.5,0,0,1,.63.32s1.5,4.43,4,5.78a.51.51,0,0,1,.19.68A.49.49,0,0,1,323.36,292.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.85,289.17a.5.5,0,0,1-.48-.38.49.49,0,0,1,.36-.6c7.22-1.83,9.72-5.61,9.74-5.65a.5.5,0,0,1,.85.54c-.11.17-2.71,4.14-10.34,6.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,285.54s-9.59-2.34-10.09-20.3c-.53-19.38,2.35-42-9-43.83s-17.65,12-17.51,28.15c.13,14.14,5.83,44.84,36.56,50.86Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,285.54s-9.59-2.34-10.09-20.3c-.53-19.38,2.35-42-9-43.83s-17.65,12-17.51,28.15c.13,14.14,5.83,44.84,36.56,50.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,298.58h-.09c-6.91-1.26-12.54-5.07-16.73-11.31-12.42-18.53-8.51-53.13-7.22-59.17a.51.51,0,0,1,.59-.39.52.52,0,0,1,.39.6c-1.27,6-5.16,40.16,7.07,58.4a24.12,24.12,0,0,0,16.08,10.88.5.5,0,0,1,.4.59A.49.49,0,0,1,208,298.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,344.67c-9.91,1.34-26,1.32-35.29-6s-7.35-13.62-3.78-16.25,6.67-5.63.53-11.47-16-15.22-19.2-29.29-1.62-22.87,4.66-25.8c6.09-2.84,7.7,1.68,11.43,11s12.12,1.33,19.3,4.24,6.89,8.67,7.34,13.62,2.82,6.32,6.89,6.32,8.12,2.34,8.12,7Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,328.33a.3.3,0,0,1-.13,0c-.43-.12-10.68-3.1-25.61-16.81-15.9-14.6-23.4-36.5-23.48-36.72a.51.51,0,0,1,.32-.63.5.5,0,0,1,.63.31c.07.22,7.5,21.88,23.21,36.3,14.72,13.53,25.09,16.56,25.2,16.59a.5.5,0,0,1,.34.62A.49.49,0,0,1,208,328.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.43,315a.48.48,0,0,1-.46-.32c-3.21-8.24-3.94-25.87-4-26.62a.51.51,0,0,1,.48-.52.53.53,0,0,1,.52.48c0,.18.75,18.21,3.9,26.3a.5.5,0,0,1-.29.65A.52.52,0,0,1,186.43,315Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.35,326.85a23.62,23.62,0,0,1-2.76-.14.5.5,0,1,1,.12-1c.09,0,9.4,1.06,13.67-3.29a.5.5,0,1,1,.71.7C195,326.31,189.61,326.85,186.35,326.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.15,137.49l-1.08-6.23-5.56,3.66a7.71,7.71,0,0,0-2.11-2.57l2.66-7.2-5-1.11-3.66,7a13.63,13.63,0,0,0-3.81,1.24L159,127l-5.94,4.67.39,6.2a33.37,33.37,0,0,0-3.28,4.34l-4.9-.25-3.44,7.71,4.21,1.8a24.68,24.68,0,0,0-.83,4.88l-5.35,4.92,1.07,6.24,5.57-3.66a7.56,7.56,0,0,0,2.11,2.56L146,173.62l5,1.1,5.24-5.1c1.21-.19.91-2.47,2.23-3.12l1.59,5.26,5.93-4.66-.15-2.44c1.2-1.34,5.74-4.29,6.72-5.83l1.23-2,3.44-7.71-1.6-2.9-1.78-3.78ZM161,158c-4.56,3.58-6,4.37-6.77-.42s1.84-12.07,6.4-15.66,6.3-3.84,7.12.94S165.57,154.46,161,158Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.1 124.04 174.59 127.78 170.93 134.76 164.44 131.02 168.1 124.04",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.56 135 179 138.66 172.51 134.92 178.07 131.26 184.56 135",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.67 152.83 179.46 151.04 172.97 147.3 177.18 149.09 183.67 152.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.99 173.62 152.48 177.35 155.14 170.15 148.65 166.41 145.99 173.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.49 175.5 160.01 171.76 158.42 166.5 164.91 170.24 166.49 175.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.63,141.23,184.56,135,179,138.66a7.74,7.74,0,0,0-2.12-2.57l2.66-7.2-4.95-1.11-3.67,7a13.63,13.63,0,0,0-3.81,1.24l-1.58-5.26-5.94,4.67.39,6.2A33.37,33.37,0,0,0,156.7,146l-4.91-.25-3.44,7.71,4.21,1.8a25.4,25.4,0,0,0-.83,4.89L146.39,165l1.07,6.24,5.56-3.66a7.7,7.7,0,0,0,2.12,2.56l-2.66,7.2,5,1.11,3.66-7a13.31,13.31,0,0,0,3.82-1.25l1.58,5.26,5.94-4.66-.39-6.2a33.37,33.37,0,0,0,3.28-4.34l4.91.24,3.44-7.71L179.45,151a24.81,24.81,0,0,0,.84-4.89ZM167.5,161.78c-4.55,3.58-8.91,2.61-9.74-2.17s2.2-11.57,6.76-15.15,8.91-2.6,9.74,2.18S172.06,158.2,167.5,161.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.53 130.74 159.04 127 153.1 131.67 159.59 135.41 165.53 130.74",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.1 131.67 153.49 137.87 159.98 141.61 159.59 135.41 153.1 131.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.7 145.95 150.21 142.21 145.31 141.97 151.79 145.71 156.7 145.95",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.31 141.97 141.87 149.67 148.35 153.41 151.79 145.71 145.31 141.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.73 160.09 145.25 156.35 139.9 161.27 146.38 165.01 151.73 160.09",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.46 171.25 140.97 167.51 139.9 161.27 146.38 165.01 147.46 171.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.59 127.78 168.1 124.04 173.06 125.15 179.54 128.89 174.59 127.78",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.09,109.21V99.9l-7.41,3.34a13.36,13.36,0,0,0-2-4.41l4.67-9.41-5.7-3.29-5.82,8.75a13.21,13.21,0,0,0-4.82.47l-.82-8.09-8.06,4.66-.81,9a39.68,39.68,0,0,0-4.82,5.1l-5.82-2-5.7,9.88,4.66,4a40.21,40.21,0,0,0-2,6.72l-7.41,5.21v9.32l7.41-3.34a13.36,13.36,0,0,0,2,4.41L103,149.64l5.7,3.29,5.82-8.75a13.23,13.23,0,0,0,4.82-.47l.81,8.09,8.06-4.66.82-9a15.2,15.2,0,0,0,6.46-4.54l4.18,1.47,5.7-9.87-3.5-3a20.81,20.81,0,0,0,.83-7.73Zm-25.93,23.26c-6.18,3.57-10,1-10-6.11s5.11-15.9,11.3-19.47,9.93-1,9.93,6.17S130.35,128.89,124.16,132.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.13 89.86 139.65 86.13 133.83 94.88 140.31 98.62 146.13 89.86",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.58 103.64 150.09 99.9 142.68 103.24 149.17 106.98 156.58 103.64",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.61 155.54 120.13 151.8 119.32 143.71 125.8 147.45 126.61 155.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.97 149.64 109.46 153.38 114.13 143.97 107.64 140.23 102.97 149.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.58,113v-9.31L149.17,107a13.17,13.17,0,0,0-2-4.41l4.67-9.41-5.7-3.3-5.82,8.76a13,13,0,0,0-4.82.47L134.68,91l-8.06,4.66-.82,9a40.38,40.38,0,0,0-4.82,5.1l-5.82-2-5.7,9.88,4.67,4a39.29,39.29,0,0,0-2,6.72l-7.41,5.21v9.32l7.41-3.34a13.16,13.16,0,0,0,2,4.41l-4.67,9.41,5.7,3.29,5.82-8.75a13.21,13.21,0,0,0,4.82-.47l.82,8.09,8.06-4.66.81-9a39.68,39.68,0,0,0,4.82-5.1l5.82,2,5.7-9.87-4.67-4a39.34,39.34,0,0,0,2-6.72Zm-25.93,23.26c-6.19,3.57-11.21.67-11.21-6.47s5-15.83,11.21-19.41,11.2-.67,11.2,6.47S136.83,132.63,130.65,136.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.5 106.04 120.98 109.78 115.16 107.75 108.68 104 114.5 106.04",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.37,
    y: 107.07,
    width: 11.41,
    height: 7.49,
    transform: "translate(-41.42 149.93) rotate(-60.02)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.97 113.88 109.46 117.62 114.13 121.64 107.64 117.91 102.97 113.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.64 124.63 112.13 128.37 104.72 133.58 98.23 129.84 105.64 124.63",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.23 129.84 104.72 133.58 104.72 142.9 98.23 139.16 98.23 129.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.68 91 128.19 87.26 120.13 91.92 126.61 95.66 134.68 91",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.88,358.05l94-54.28a1.06,1.06,0,0,0,0-2l-8.69-5a3.86,3.86,0,0,0-3.47,0L205.69,351a1.06,1.06,0,0,0,0,2l8.72,5A3.86,3.86,0,0,0,217.88,358.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3,94.2l-84.76,48.94a9.58,9.58,0,0,0-4.33,7.5V351.71c0,2.76,1.94,3.88,4.33,2.5l84.76-48.94a9.55,9.55,0,0,0,4.33-7.5V96.7C313.63,93.94,311.7,92.82,309.3,94.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.54,143.14,309.3,94.2c2.14-1.24,3.91-.47,4.27,1.68a9.68,9.68,0,0,0-4.27-6.68l-3.52-2a9.57,9.57,0,0,0-8.66,0L212.35,136.1a8.91,8.91,0,0,0-3.06,3.23l12.19,7A8.75,8.75,0,0,1,224.54,143.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,344.67a9.58,9.58,0,0,0,4.33,7.5l3.53,2a9.7,9.7,0,0,0,7.92.34c-2,.78-3.59-.37-3.59-2.84V150.64a8.8,8.8,0,0,1,1.27-4.27l-12.19-7A8.91,8.91,0,0,0,208,143.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.87,169.93,307,123.68c1.44-.82,2.6-.15,2.6,1.5V274a5.73,5.73,0,0,1-2.6,4.5l-80.1,46.25c-1.44.83-2.6.16-2.6-1.5V174.43A5.74,5.74,0,0,1,226.87,169.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.92,126.29a3.38,3.38,0,0,0-1.52,2.64c0,1,.68,1.37,1.52.88a3.35,3.35,0,0,0,1.52-2.64C268.44,126.2,267.76,125.81,266.92,126.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.92,308.74a13.3,13.3,0,0,0-6,10.42c0,3.83,2.69,5.39,6,3.47a13.31,13.31,0,0,0,6-10.42C272.94,308.38,270.24,306.82,266.92,308.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.53,141.77a6.73,6.73,0,0,0-3,5.28c0,1.94,1.36,2.73,3,1.76a6.73,6.73,0,0,0,3.05-5.28C255.58,141.59,254.22,140.8,252.53,141.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,141.11c0,1.3,1,1.79,2.17,1.1l20-11.57a4.64,4.64,0,0,0,2.17-3.6c0-1.29-1-1.78-2.17-1.09l-20,11.57A4.64,4.64,0,0,0,260,141.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.76,176.37a5.39,5.39,0,0,1,2.44,4.22c0,1.56-1.09,2.19-2.44,1.41a5.4,5.4,0,0,1-2.43-4.22C212.33,176.23,213.42,175.6,214.76,176.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.76,195.15a5.39,5.39,0,0,1,2.44,4.22c0,1.55-1.09,2.18-2.44,1.41a5.4,5.4,0,0,1-2.43-4.22C212.33,195,213.42,194.37,214.76,195.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,176.75a5.39,5.39,0,0,1,2.44,4.22c0,1.55-1.09,2.18-2.44,1.41a5.39,5.39,0,0,1-2.44-4.22C211.57,176.6,212.66,176,214,176.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,195.52a5.39,5.39,0,0,1,2.44,4.23c0,1.55-1.09,2.18-2.44,1.4a5.36,5.36,0,0,1-2.44-4.22C211.57,195.38,212.66,194.75,214,195.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82,129.89c0-1.66-1.16-2.33-2.6-1.5l-9.59,5.53-70.51,40.72a5.73,5.73,0,0,0-2.6,4.5V327.92c0,1.66,1.16,2.33,2.6,1.5l70.54-40.73,9.56-5.52a5.73,5.73,0,0,0,2.6-4.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.82,129.89a2.57,2.57,0,0,0-4.1-2.37l-9.15,5.29h0l-70.95,41a6.66,6.66,0,0,0-3.1,5.37V327.92a2.77,2.77,0,0,0,1.26,2.55,2.29,2.29,0,0,0,1.18.31,3.42,3.42,0,0,0,1.66-.49l71-41h0l9.13-5.27a6.75,6.75,0,0,0,3.1-5.37ZM313.59,287.58l0,0-.82.48h0l-70.11,40.48a1,1,0,0,1-.84.18c-.13-.08-.26-.36-.26-.82V179.14a4.81,4.81,0,0,1,2.1-3.64L313.7,135h0l10-5.79a1,1,0,0,1,.84-.18c.13.08.26.36.26.82V278.67a4.81,4.81,0,0,1-2.1,3.64l-9.13,5.27Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.17,164.46c9-5.18,16.25-1,16.25,9.39s-7.28,23-16.25,28.14-16.25,1-16.25-9.38S274.2,169.65,283.17,164.46Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.17,172.62c2.91-1.68,5.27-.32,5.27,3a11.65,11.65,0,0,1-5.27,9.13c-2.91,1.68-5.27.32-5.27-3A11.65,11.65,0,0,1,283.17,172.62Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.44,190.54c0-5.52-3.87-7.76-8.66-5l-3,1.73c-4.78,2.76-8.66,9.48-8.66,15v1.49c2.77.91,6.25.42,10-1.77a32,32,0,0,0,10.27-10.17Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.17,172.62c2.91-1.68,5.27-.32,5.27,3a11.65,11.65,0,0,1-5.27,9.13c-2.91,1.68-5.27.32-5.27-3A11.65,11.65,0,0,1,283.17,172.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.44,190.54c0-5.52-3.87-7.76-8.66-5l-3,1.73c-4.78,2.76-8.66,9.48-8.66,15v1.49c2.77.91,6.25.42,10-1.77a32,32,0,0,0,10.27-10.17Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,224.84l20.91-12.07c1-.55,1.73-.11,1.73,1v.69a3.82,3.82,0,0,1-1.73,3l-20.91,12.07c-.95.55-1.73.1-1.73-1v-.69A3.83,3.83,0,0,1,251.73,224.84Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,224.84l20.91-12.07c1-.55,1.73-.11,1.73,1v.69a3.82,3.82,0,0,1-1.73,3l-20.91,12.07c-.95.55-1.73.1-1.73-1v-.69A3.83,3.83,0,0,1,251.73,224.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.87,239.41l63.26-36.52c.47-.28.86-.06.86.5v7.38a1.94,1.94,0,0,1-.86,1.5l-63.26,36.52c-.48.28-.87.05-.87-.5v-7.38A1.92,1.92,0,0,1,250.87,239.41Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.87,239.41l63.26-36.52c.47-.28.86-.06.86.5v7.38a1.94,1.94,0,0,1-.86,1.5l-63.26,36.52c-.48.28-.87.05-.87-.5v-7.38A1.92,1.92,0,0,1,250.87,239.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,257.67l20.91-12.07c1-.55,1.73-.1,1.73,1v.69a3.81,3.81,0,0,1-1.73,3l-20.91,12.07c-.95.56-1.73.11-1.73-1v-.69A3.85,3.85,0,0,1,251.73,257.67Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,257.67l20.91-12.07c1-.55,1.73-.1,1.73,1v.69a3.81,3.81,0,0,1-1.73,3l-20.91,12.07c-.95.56-1.73.11-1.73-1v-.69A3.85,3.85,0,0,1,251.73,257.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.87,272.24l63.26-36.52c.47-.28.86-.05.86.5v7.38a1.94,1.94,0,0,1-.86,1.5l-63.26,36.52c-.48.28-.87.06-.87-.5v-7.38A1.92,1.92,0,0,1,250.87,272.24Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.87,272.24l63.26-36.52c.47-.28.86-.05.86.5v7.38a1.94,1.94,0,0,1-.86,1.5l-63.26,36.52c-.48.28-.87.06-.87-.5v-7.38A1.92,1.92,0,0,1,250.87,272.24Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.1,276.43l25-14.41c1-.56,1.74-.11,1.74,1v7.72a3.82,3.82,0,0,1-1.74,3l-25,14.42c-1,.55-1.73.1-1.73-1v-7.73A3.86,3.86,0,0,1,276.1,276.43Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.1,276.43l25-14.41c1-.56,1.74-.11,1.74,1v7.72a3.82,3.82,0,0,1-1.74,3l-25,14.42c-1,.55-1.73.1-1.73-1v-7.73A3.86,3.86,0,0,1,276.1,276.43Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.3,243.85s-12.28-16.94-13-19c-.57-1.52,0-3.78.18-4.83s.34-3.39.52-4c.3-1.14-1.17-.91-2,.13s-1.11,3.12-1.54,3.46-3.7-4.43-5.41-6.63-2.78-3.54-3.83-2.72c-.75.59-.19,1.87,1.05,3.75a33.77,33.77,0,0,1,2,3.15c.19.41-.83.44-1.38,1.29-.43.66,0,1.73-.6,2.24a1.89,1.89,0,0,0-.48,2.47,16.34,16.34,0,0,0,4.23,4.48c1.84,1.27,2.58,1.72,3.67,3.45s10.87,19.4,11.53,20.46,1.93,3.22,3.86,3.28,17.73-13.54,18.54-14.22c2.6-2.17,3.43-2.48,3.87-.53a19.25,19.25,0,0,1,.34,2.1c.31,2.48,2,11.34,2,11.34s8,3.87,14.57,2,8.79-4.66,8.79-4.66l-3.29-5.36c.89-2.21,5-11.17,6.33-17.44l-20.6-3.33c-.42-.09-1.1-.26-2-.49-1.13-.3-4-1.29-6.17.61-7.08,6.17-21.16,19-21.16,19",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.14,347.79l-3.69,5.13a12.26,12.26,0,0,0,5.36,1.15c3.31.12,4.22-1,4.34-1.22.56-1.2-.31-3.36-.55-5.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.66,350.46s-4.48-.29-7.57-.67-5.54,1.12-4.82,2.39,2.43,2.33,5.09,3.22c2.27.77,5,1.32,7.36,2s4,1.57,5.37,1.09c1.53-.53,2.19-1.14,2.06-2.26a48.54,48.54,0,0,0-1.24-4.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.15,342.64s-.56,4.66-.6,5.66-4.55,1.32-5.41-.51l-.14-5.7Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.61,345.5l1.61,7.08s.15.86-3.53,1.41-9.46-1.93-10.45-2.43-1.1-1.51,2.52-1.31,4.9.21,4.9.21l-1.18-3.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.19,228l2.55-.71s5.33,16.87,5.92,18.5,1.26,3.35.11,5.36c-1.37,2.39-8.58,12-8.58,12l-4.58-4.48,5.2-9.52-4.6-9.3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,206.09a7.52,7.52,0,0,1,.11-7.27c2.54-4.71,8.2-7,14.94-6.13,3.12.41,6.8,3,8.81,6.87,2.22,4.29,2.43,12.93,3,16.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.82,207.94s-1.6,3.05-1.32,3.33a4.19,4.19,0,0,0,1.34.5Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.68,198.3c-1.74,1.13-4.74,3.21-4.87,10.06-.14,7,.86,9.31,1.9,10.12.7.55,4.81.27,6.57-.14s6.83-2.92,8.66-6.73c2.15-4.48,1.71-11-1.48-13A11.14,11.14,0,0,0,363.68,198.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.15,250.82c3.08,4.8,6,9,6.64,14.42,1.32,11.39-3,24.41-3.93,32.84a15.19,15.19,0,0,1,2.9,8.22c0,3.49-5.61,36.34-5.61,36.34s-4.08,1.24-6.15-.55l-3.85-60.43,2-7.36Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.15,250.82c3.08,4.8,6,9,6.64,14.42,1.32,11.39-3,24.41-3.93,32.84a15.19,15.19,0,0,1,2.9,8.22c0,3.49-5.61,36.34-5.61,36.34s-4.08,1.24-6.15-.55l-3.85-60.43,2-7.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.15,281.66l2-7.36a49.13,49.13,0,0,0,11-4.37s-2.08,3.79-8.06,5.87L374,285.25l-.26,21.65Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.15,281.66l2-7.36a49.13,49.13,0,0,0,11-4.37s-2.08,3.79-8.06,5.87L374,285.25l-.26,21.65Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.15,250.82c1.65,2.7,5.59,7.3,4.75,11.73-1,5.36-3.9,9.13-12.72,11.75l-8.28,30s4.31,4,5.63,7.87,6.08,33.35,6.08,33.35-1.48,2.41-6.13,1.83c0,0-16.21-37-17.35-39.41a12,12,0,0,1-1.37-8.05c.51-3.88,6-46.35,6-46.35Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.15,250.82c1.65,2.7,5.59,7.3,4.75,11.73-1,5.36-3.9,9.13-12.72,11.75l-8.28,30s4.31,4,5.63,7.87,6.08,33.35,6.08,33.35-1.48,2.41-6.13,1.83c0,0-16.21-37-17.35-39.41a12,12,0,0,1-1.37-8.05c.51-3.88,6-46.35,6-46.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.19,228l-20.6-3.33c-.42-.09-1.1-.26-2-.49h0s-.88,12.92-6.17,15.88h0c.13.62.24,1.31.34,2.1.31,2.48,2,11.34,2,11.34s8,3.87,14.57,2,8.79-4.66,8.79-4.66l-3.29-5.36C379.75,243.25,383.89,234.29,385.19,228Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.19,228l-20.6-3.33c-.42-.09-1.1-.26-2-.49h0s-.88,12.92-6.17,15.88h0c.13.62.24,1.31.34,2.1.31,2.48,2,11.34,2,11.34s8,3.87,14.57,2,8.79-4.66,8.79-4.66l-3.29-5.36C379.75,243.25,383.89,234.29,385.19,228Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.76,243.35a58.15,58.15,0,0,1-8.57,4.23,16.1,16.1,0,0,0,7.67-2.12Z",
    style: {
      fill: "#44C9F6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.17,198.64s-1,6.5,1.36,10.32c0,0,.88-2.59,3.07-2.1s2.31,3.38.77,5a3.19,3.19,0,0,1-3.24,1s-.35,4.7-.54,8.64-1.23,12.53,3.2,16,15.55,4.69,20.76-2.59c2.9-4.05-.95-11.21-2.74-19.24-1.65-7.38-2.58-18.32-10.41-20.08S363.17,198.64,363.17,198.64Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.9,109.83l-1.65,1a8.7,8.7,0,0,0,.23-1.79c0-3.35-2.35-4.7-5.25-3a9.26,9.26,0,0,0-2.33,2v0c0-4.5-3.16-6.33-7.06-4.08a15.61,15.61,0,0,0-7.06,12.23c0,.23,0,.45,0,.67a4.28,4.28,0,0,0-2.87.66,11.6,11.6,0,0,0-5.25,9.09,6.1,6.1,0,0,0,.13,1.26l-.88.51c-2.39,1.38-4.33,4.07-4.33,6s1.94,2.39,4.33,1l32-18.45c2.39-1.38,4.33-4.07,4.33-6S394.29,108.44,391.9,109.83Z",
    style: {
      fill: "#ebebeb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin1);
export default __webpack_public_path__ + "static/media/login-1.bcca104e903b4de08092eb779c98b000.svg";
export { ForwardRef as ReactComponent };